import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";

@Component({
  selector: "app-promo-chat-progress-panel",
  templateUrl: "./promo-chat-progress-panel.component.html",
  styleUrls: ["./promo-chat-progress-panel.component.scss"],
})
export class PromoChatProgressPanelComponent implements AfterViewInit, OnChanges {
  @Input() combinedQuestionList: any[] = [];
  @Input() initialAnsweredQues: number;
  @Input() promotionEditOrCopy: boolean = false;
  @Input() pageno: number;
  @Input() progressVal: number = 0;
  @Input() userData: any;
  @Input() customConfigData: any;
  @Input() budgetCapAmtMain: any = [];
  @Input() budgetCapAmtForRegions: any = {};
  @Output() navigateToQuestion = new EventEmitter<any>();

  @ViewChild("scrollChatCard") scrollChatCardContainer: ElementRef;
  scrollContainer: any;
  disableScrollTop: boolean = true;
  disableScrollBottom: boolean = false;

  ngAfterViewInit() {
    setTimeout(() => {
      this.scrollContainer = this.scrollChatCardContainer.nativeElement;
      this.scrollToBottom();
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["pageno"] && !changes["pageno"].firstChange) {
      setTimeout(() => {
        this.scrollToBottom();
      }, 0);
    }
  }

  scrollHandler(event) {
    if (
      event.target.offsetHeight + event.target.scrollTop >=
      event.target.scrollHeight
    ) {
      this.disableScrollBottom = true;
    } else if (event.target.scrollTop == 0) {
      this.disableScrollTop = true;
    } else {
      this.disableScrollTop = false;
      this.disableScrollBottom = false;
    }
  }

  scrollToBottom(): void {
    if (this.combinedQuestionList[this.pageno] != null) {
      let el = document.getElementById(
        "chat" + this.combinedQuestionList[this.pageno].identifier
      );
      this.scrollContainer.scroll({
        top: el.offsetTop - 200,
        behavior: "smooth",
      });
    }
  }

  scrollToTopLayout() {
    this.scrollChatCardContainer.nativeElement.scrollTo({
      left: 0,
      top: 0,
      behavior: "smooth",
    });
  }

  scrollToBottomLayout() {
    this.scrollChatCardContainer.nativeElement.scrollTo({
      left: 0,
      top: this.scrollChatCardContainer.nativeElement.scrollHeight,
      behavior: "smooth",
    });
  }

  getMultiSelectVals(item) {
    let selectedVal = this.customConfigData.challengeCriteria.criterias.find(
      (criteria) => {
        if (criteria.questionInfo.questionIdentifier === item.identifier) {
          return criteria;
        }
      }
    );
    if (
      item.identifier === "COUNTRY_INCLUDE" ||
      item.identifier === "COUNTRY_EXCLUDE"
    ) {
      return selectedVal.acceptedValues.length <= 5
        ? selectedVal.acceptedValues.map((x) => x.label).toString()
        : selectedVal.acceptedValues.length + " Records";
    }
    return selectedVal.acceptedValues.length <= 5
      ? selectedVal.acceptedValues.toString()
      : selectedVal.acceptedValues.length + " Records";
  }

  getEmailIds(questionInfo) {
    if (typeof this.customConfigData[questionInfo.identifier] == "object") {
      return this.customConfigData[questionInfo.identifier]
        .join(",")
        .toString();
    } else {
      return this.customConfigData[questionInfo.identifier];
    }
  }

  getTextAreaContent(questionInfo) {
    let selectedVal = this.customConfigData.challengeCriteria.criterias.find(
      (criteria) => {
        if (
          criteria.questionInfo.questionIdentifier === questionInfo.identifier
        ) {
          return criteria;
        }
      }
    );
    return selectedVal.acceptedValues.toString();
  }

  getSelectedDates() {
    return `Start Date - ${new Date(
      this.customConfigData["startDate"]
    ).toDateString()}<br>End Date - ${new Date(
      this.customConfigData["endDate"]
    ).toDateString()}`;
  }

  getSelectedDate(item) {
    return new Date(this.customConfigData[item.identifier]).toDateString();
  }

  getBudgetForRegions() {
    let text = "";
    for (let property in this.budgetCapAmtForRegions) {
      text += `${property} - ${this.budgetCapAmtForRegions[property]}<br>`;
    }
    return text;
  }
}
